import { api } from './client'

export function fetchPostureThresholds() {
  return api.get('/posture/thresholds').then((r) => r.data)
}

export function updatePostureThresholds(body) {
  return api.put('/posture/thresholds', body).then((r) => r.data)
}
